import * as Sentry from "@sentry/tanstackstart-react";
// src/client.tsx
import { StartClient } from "@tanstack/react-start/client";
import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";

import { env } from "@/env/public-env";
import { installBrowserOtelTracing } from "@/infrastructure/browser-otel-tracing";
import { markExpectedTRPCErrorInEvent } from "@/infrastructure/sentry-utils";

import { getRouter } from "./router";

const router = getRouter();

const isDev = env.VITE_ENVIRONMENT === "dev";
const sampleRate = isDev ? 1.0 : 0.1;

Sentry.init({
  ...(env.VITE_SENTRY_DSN && { dsn: env.VITE_SENTRY_DSN }),
  dataCollection: { frameContextLines: 7, userInfo: true },
  environment: env.VITE_ENVIRONMENT,
  release: env.VITE_VERSION,
  dist: "client",
  spotlight: isDev,
  integrations: [
    Sentry.tanstackRouterBrowserTracingIntegration(router),
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration({
      colorScheme: "system",
      autoInject: false,
    }),
    ...(isDev
      ? [Sentry.spotlightBrowserIntegration()]
      : []),
  ],
  tracesSampleRate: sampleRate,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event, hint) {
    const error = hint.originalException;

    // Mark expected TRPC errors as handled (still logged, but won't create issues)
    return markExpectedTRPCErrorInEvent(event, error);
  },
});

installBrowserOtelTracing(env);

hydrateRoot(
  document,
  <StrictMode>
    <StartClient />
  </StrictMode>
);
